import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ApiKey } from '../../config/key';
import { ContainerSearchGame } from './style';

export default function Search() {
    const { gameName } = useParams();
    const [ games, setGames ] = useState([]);

    useEffect(() => {
          fetch(`https://api.rawg.io/api/games?search=${gameName.replace(/-/ig, ' ')}&key=${ApiKey}&language=pt`)
          .then(Response => Response.json())
          .then(data => {
            console.log(data)
            setGames(data.results)
          });
    }, [gameName]);

    return (
        <ContainerSearchGame>
            <div className="games">
                {games.map((game)=> {
                    return (
                        <Link to={`/game/${(game.name).replace(/ /ig, '-')}/${game.id}`}>
                            <div className="game" key={`${game.name}-${game.id}`}>
                                <img loading="lazy" src={game.background_image} alt={game.name}/>
                                <h2 className="name-game">{game.name}</h2>
                                <div className="details-game">
                                    {game.parent_platforms &&
                                        <div className="platforms">
                                            {game.parent_platforms.map((platform)=> {
                                                return (
                                                    <div key={`${platform.platform.name}-${platform.platform.id}`} className="platform">
                                                        {platform.platform.slug == "pc" ?
                                                            <span><i className="fa-brands fa-windows"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "commodore-amiga" ?
                                                            <span><i className="fa-solid fa-tv"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "web" ?
                                                            <span><i className="fa-solid fa-globe"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "playstation" ?
                                                            <span><i className="fa-brands fa-playstation"></i></span> : ""
                                                        }
                                                        { platform.platform.slug == "xbox" ?
                                                            <span><i className="fa-brands fa-xbox"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "linux" ?
                                                            <span><i className="fa-brands fa-linux"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "ios" ?
                                                            <span><i className="fa-brands fa-app-store-ios"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "mac" ?
                                                            <span><i className="fa-brands fa-apple"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "android" ?
                                                            <span><i className="fa-brands fa-android"></i></span> : ""
                                                        }
                                                        {platform.platform.slug == "nintendo" || platform.platform.slug == "atari" || platform.platform.slug == "sega" || platform.platform.slug == "3do" || platform.platform.slug == "neo-geo" ?
                                                            <span><i className="fa-solid fa-gamepad"></i></span> : ""
                                                        } 
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                    {game.released ?
                                        <span className="year">{game.released.slice(0, 4)}</span>
                                        : <span className="year">2000</span>
                                    }
                                    {game.rating ?
                                        <span className={`rating ${game.rating < 3 ? 'rating-bad' : game.rating < 4 ? 'rating-medium' : game.rating >= 4 ? 'rating-good' : ''}`}>{game.rating.toFixed(1)}</span>
                                        : <span className={`rating rating-bad`}>0</span>
                                    }
                                    {game.genres &&
                                        <div className="genres">
                                            {game.genres.map((genre) => {
                                                return (
                                                <a key={`${genre.name}-${genre.id}`} href="#">{genre.name}</a>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>
        </ContainerSearchGame>
    )
}